// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  MaterialList
}                         from '../../../components';
import styles                 from './style';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../services/fetchTools';
import {Link} from 'react-router-dom';
import FlatButton from 'material-ui/FlatButton';
import styled from 'styled-components';
import { Spinner } from 'react-activity';
import Dialog from 'material-ui/Dialog';
import { Multiselect } from 'react-widgets';
import CreateFixture from '../../partner/crud/createFixture';
import PartnerAllocation from '../../partner/partnerAllocation';
import ReplaceBuddy from '../crud/replaceBuddy';
import AddBuddy from '../crud/addBuddy';
import HostGame from '../../partner/crud/hostGame';

class CheckoutSummary extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      venue:props.venue,
      court_booking_summary:[],
      bulk_booking_summary:[],
      membership_summary:[],
      court_bookings:true,
      bulk_bookings:false,
      memberships:false,
      court_success:false,
      bulk_success:false,
      mem_success:false
    };
    this.handleSelection = this.handleSelection.bind(this);
  }

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('Home');

    // this.getCourtBookings()
  }

  componentDidMount() {
    // this.getAllBuddies();

    
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('Home');
  }

  reload(){
    this.getCourtBookings()
  }

  getCourtBookings(){
    const url = `${getLocationOrigin()}/cm/get_court_booking_summary/?venue=${this.props.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({venue:this.props.venue,court_booking_summary:data.result,court_success:data.success,bulk_success:false,mem_success:false});
        }).catch(error => error);
    }

  getBulkBookings(){
    const url = `${getLocationOrigin()}/cm/get_bulk_booking_summary/?venue=${this.props.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({venue:this.props.venue,bulk_booking_summary:data.result,bulk_success:true,court_success:false,mem_success:false});
    }).catch(error => error);
    }

  getMemberships(){
    const url = `${getLocationOrigin()}/cm/get_membership_summary/?venue=${this.props.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({venue:this.props.venue,membership_summary:data.result,mem_success:true,court_success:false,bulk_success:false});
    }).catch(error => error);
  }

  handleSelection(event){
    const name = event.target.name
    if(name == 'court_bookings'){
      this.setState({court_bookings:true,bulk_bookings:false,memberships:false})
    }
    else if(name == 'bulk_bookings'){
      this.setState({bulk_bookings:true,court_bookings:false,memberships:false})
    }
    else if(name == 'memberships'){
      this.setState({memberships:true,court_bookings:false,bulk_bookings:false})
    }
  }

  renderCourtBooking(){
    console.log('props',this.props.venue)
    if((this.state.court_booking_summary == 0 && !this.state.court_success) || this.state.venue != this.props.venue){
      this.getCourtBookings()
    }
    var header = ['Booking Date','Session Time','Court','Customer','Total Amount','Amount Paid','Coupon','Payment Mode']

    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Today's Court Bookings</div> 
        <table className="table_plain">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.court_booking_summary && this.state.court_booking_summary.length > 0 ?
              this.state.court_booking_summary.map((data,index)=>
              <tr>
                <td>{data.date}</td>
                <td>{data.time}</td>
                <td>{data.court} </td>
                <td>{data.customer}</td>
                <td>{data.amount}</td>
                <td>{data.amount_paid}</td>
                <td>{data.coupon}</td>
                <td>{data.payment_mode}</td>
              </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderBulkBooking(){
    if((this.state.bulk_booking_summary == 0 && !this.state.bulk_success) || this.state.venue != this.props.venue){
      this.getBulkBookings()
    }
    var header = ['Booking Date','Time','Customer','Total Amount','Amount Paid','Coupon','Payment Mode']

    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Today's Bulk Bookings</div> 
        <table className="table_plain">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.bulk_booking_summary && this.state.bulk_booking_summary.length > 0 ?
              this.state.bulk_booking_summary.map((data,index)=>
              <tr>
                <td>{data.date}</td>
                <td>{data.start_time} - {data.end_time}</td>
                <td>{data.customer}</td>
                <td>{data.amount}</td>
                <td>{data.amount_paid}</td>
                <td>{data.coupon}</td>
                <td>{data.payment_mode}</td>
              </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
            }
        </table>
      </div>
      )
  }

  renderMembership(){
    if((this.state.membership_summary == 0 && !this.state.mem_success) || this.state.venue != this.props.venue){
      this.getMemberships()
    }
    var header = ['Booking Time','Package','Customer','Total Amount','Amount Paid','Coupon','Payment Mode']

    return(
      <div className='col-md-12 table_container1' style={styles.table}>
        <div className="heading heading2 left" style={styles.header}>Today's Memberships</div> 
        <table className="table_plain">
          <tr> 
            { header && header.length > 0 &&
              header.map((head)=>
                <th>{head}</th>
                )
             }
          </tr>
          
            { this.state.membership_summary && this.state.membership_summary.length > 0 ?
              this.state.membership_summary.map((data,index)=>
              <tr>
                <td>{data.time}</td>
                <td>{data.package}</td>
                <td>{data.customer}</td>
                <td>{data.amount}</td>
                <td>{data.amount_paid}</td>
                <td>{data.coupon}</td>
                <td>{data.payment_mode}</td>
              </tr>
                )
              :
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}> No Data Available</div>
              </div>
            }
        </table>
      </div>
      )
  }

  render() {
    console.log('check venue',this.state)
    // if(this.props.venue != this.state.venue){
    //   this.reload()
    // }
    
    return(
          <div className='col-md-12' style={{margin:'2%'}}>
            <div className='col-md-12' style={{padding:'0px',width:'100%'}}>
              <button className='button1' style={this.state.court_bookings?{marginRight:'1%',opacity:'0.6'}:{marginRight:'1%'}} name='court_bookings' onClick={this.handleSelection}> Court Bookings </button>
              <button className='button1' style={this.state.bulk_bookings?{marginRight:'1%',opacity:'0.6'}:{marginRight:'1%'}} name='bulk_bookings' onClick={this.handleSelection}> Bulk Bookings </button>
              <button className='button1' style={this.state.memberships?{marginRight:'1%',opacity:'0.6'}:{marginRight:'1%'}} name='memberships' onClick={this.handleSelection}> Memberships </button>
            </div>

              {
                this.state.court_bookings &&
                this.renderCourtBooking()
              }

              {
                this.state.bulk_bookings &&
                this.renderBulkBooking()
              }

              {
                this.state.memberships &&
                this.renderMembership()
              }

      </div>
    );
  }
}

export default CheckoutSummary;



// WEBPACK FOOTER //
// ./src/app/views/centerportal/CheckoutSummary/CheckoutSummary.js